import { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { CLUB_ID, THEME_COLOR } from "../../config/club";
import Swal from "sweetalert2";

export default function CreateReservationModal({ show, onClose, onSuccess }) {
    const [form, setForm] = useState({
        name: "RRC - Weekend Game",
        date: "",
        startTime: "17:00",
        endTime: "22:00",
        maxSlots: 32,
    });

    const [loading, setLoading] = useState(false);

    if (!show) return null;

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async () => {
        if (!form.date || !form.startTime || !form.endTime) {
            Swal.fire("Required", "Please pick a date and time", "warning");
            return;
        }

        try {
            setLoading(true);
            await addDoc(collection(db, "clubs", CLUB_ID, "reservations"), {
                name: form.name || "Reservation Slot",
                date: form.date,
                startTime: form.startTime,
                endTime: form.endTime,
                maxSlots: Number(form.maxSlots),
                reservedCount: 0,
                status: "open",
                createdAt: serverTimestamp(),
            });

            Swal.fire({
                icon: "success",
                title: "Created!",
                showConfirmButton: false,
                timer: 1500
            });

            onSuccess?.();
            onClose();
        } catch (err) {
            console.error(err);
            Swal.fire("Error", "Failed to create reservation", "error");
        } finally {
            setLoading(false);
        }
    };

    const inputStyle = {
        borderRadius: '12px',
        border: '1px solid var(--border-color)',
        padding: '12px 15px',
        fontSize: '0.95rem'
    };

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center animate__animated animate__fadeIn"
            style={{
                background: "rgba(0,0,0,0.6)",
                backdropFilter: "blur(8px)",
                zIndex: 1050,
            }}
            onClick={onClose}
        >
            <div
                className="bento-card p-4 shadow-lg border-0 m-3 animate__animated animate__zoomIn"
                style={{ width: "100%", maxWidth: "450px", backgroundColor: 'var(--card-bg)' }}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="fw-black mb-0" style={{ color: THEME_COLOR }}>
                        New Session
                    </h4>
                    <button className="btn-close" onClick={onClose}></button>
                </div>

                <div className="d-flex flex-column gap-4">
                    {/* SESSION NAME */}
                    <div className="form-group">
                        <label className="rank-label mb-2 d-block">Session Title</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control"
                            style={inputStyle}
                            placeholder="e.g. Saturday Night Smash"
                            value={form.name}
                            onChange={handleChange}
                        />
                    </div>

                    {/* DATE */}
                    <div className="form-group">
                        <label className="rank-label mb-2 d-block">Event Date</label>
                        <input
                            type="date"
                            name="date"
                            className="form-control"
                            style={inputStyle}
                            value={form.date}
                            onChange={handleChange}
                        />
                    </div>

                    {/* TIME SLOTS */}
                    <div className="row g-3">
                        <div className="col-6">
                            <label className="rank-label mb-2 d-block">Starts</label>
                            <input
                                type="time"
                                name="startTime"
                                className="form-control"
                                style={inputStyle}
                                value={form.startTime}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="col-6">
                            <label className="rank-label mb-2 d-block">Ends</label>
                            <input
                                type="time"
                                name="endTime"
                                className="form-control"
                                style={inputStyle}
                                value={form.endTime}
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* MAX SLOTS */}
                    <div className="form-group">
                        <label className="rank-label mb-2 d-block">Max Player Slots</label>
                        <div className="d-flex align-items-center gap-3">
                            <i className="bi bi-people text-muted h5 mb-0"></i>
                            <input
                                type="number"
                                name="maxSlots"
                                className="form-control fw-bold"
                                style={{ ...inputStyle, width: '100px' }}
                                min={1}
                                value={form.maxSlots}
                                onChange={handleChange}
                            />
                            <span className="text-muted small">Players total</span>
                        </div>
                    </div>
                </div>

                {/* ACTIONS */}
                <div className="d-flex gap-2 mt-5">
                    <button
                        className="btn btn-light rounded-pill flex-grow-1 fw-bold py-2"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn rounded-pill flex-grow-1 fw-black py-2 text-white shadow-sm"
                        style={{ background: THEME_COLOR }}
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? (
                            <span className="spinner-border spinner-border-sm me-2"></span>
                        ) : "Create Slot"}
                    </button>
                </div>
            </div>
        </div>
    );
}